<template>

    <div class="scope-of-works-item" v-if="item">
        <div class="item-info">
            <strong>{{ item.reference }}: </strong> {{ item.description }} <span>{{ item.qty }} {{ item.unit }}</span>
        </div>

        <div class="children" v-if="item.children.length">
            <sow-looper :items="item.children"></sow-looper>
        </div>
    </div>

</template>

<script>
    export default {
        props: ['item'],
    }
</script>

<style lang="scss" scoped>
    .children {
        padding-left: 1em;
    }

    .item-info {
        @include clearfix();
        padding: 1em;
        background-color: #fbfbfb;
        border-radius: $standardBorderRadius;
        display:block;
        margin:0.5em 0;
        strong{
            font-weight:700;
            color:$brand;
        }
        span{
            float:right;
        }
    }

</style>
